import GiftCardCWHCPrint from "./giftCardCWHCPrinter";
import Axios from "axios";
import env from "../../config/env";
import CWOpenDrawer from "./CWOpenDrawer";
import printToken from "./printTokens";
import CWKOTPrinter from "./CWKotPrinter";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { processReceiptTemplate, replacePlaceholders, getDeepValue, formatValue } from "./templateProcessor";
import useAuthStore from "../../stores/useAuthStore";
import usePOSConfigStore from "../../stores/usePOSConfigStore";
import useTransactionStore from "../../stores/useTransactionStore";
import useRestaurantStore from "../../stores/useRestaurantStore";
import { getIsInterState } from "../../utils/taxUtils";

const CWHCPrint = (printData, PStatus) => {
  let receiptData = { ...printData };
  console.log("receiptData --------->", receiptData);
  const posConfig = usePOSConfigStore.getState().posConfig;
  const tillData = useAuthStore.getState().tillData;
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision;
  receiptData.time = receiptData.orderTime ? receiptData.orderTime.split(" ").pop() : "";
  const disableAggregatorKOTPrint = process.env.REACT_APP_DISABLE_AGGREGATOR_KOT_PRINT === "true";

  receiptData.items = (receiptData.items || []).filter((item) => {
    return !(item.nettotal === 0 && item.unitTax === 0 && item.netStd === 0 && item.type !== "S" && item?.itemType !== "TGD");
  });
  receiptData.items = (receiptData.items || []).filter((item) => {
    return item?.orderStatus !== "CL";
  });
  receiptData.items = (receiptData.items || []).filter((item) => {
    return item?.productSegment !== "BG";
  });
  receiptData.items = (receiptData.items || []).map((item, index) => {
    item.sno = index + 1;
    item.addons = (item.addons || []).map((addon) => ({
      name: "+ " + addon?.name,
      qty: addon?.qty,
      mrp: addon?.price,
      amount: addon?.qty * addon?.price,
    }));

    return item;
  });

  receiptData.total = Number((receiptData.total + Number(receiptData.overPayedAmount || 0)).toFixed(pricePrecision ?? 2));
  receiptData.totalStd = Number((receiptData.totalStd + Number(receiptData.overPayedAmount || 0)).toFixed(pricePrecision ?? 2));

  const overPayed = Number(receiptData.overPayedAmount || 0);

  receiptData.payments = receiptData?.payments?.map((payment) => {
    let amount = Number(payment.amount);

    // Cash payment → apply rounding
    if (payment.roundOffForPos === "Y" && payment.integratedPayment === false) {
      amount = Number((amount + overPayed).toFixed(pricePrecision ?? 2));
    } else {
      // Non-cash → just fix precision
      amount = Number(amount.toFixed(pricePrecision ?? 2));
    }

    return {
      ...payment,
      amount,
    };
  });

  const formatExactDateTime = (dateStr) => {
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-");
    let [hours, minutes, seconds] = timePart.split(":");

    hours = Number(hours);
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // convert 0 -> 12

    return `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  if (receiptData?.deliveryDate) {
    receiptData.deliveryDate = formatExactDateTime(receiptData?.deliveryDate);
  }

  const currentDate = new Date().toISOString().split("T")[0];
  const storedTokenData = useRestaurantStore.getState().tokenData || {};
  const lastDate = storedTokenData.date || "";
  let tokenCounter = storedTokenData[lastDate] || 0;

  if (lastDate !== currentDate) {
    tokenCounter = 0; // Reset token counter if date changes
  }

  // Initialize vendors as an array
  const vendors = [];

  // Group items by productionCenter only for items with a valid productionCenterId
  const productionCenters = {};
  let hasProductionCenter = false;
  (receiptData.items || []).forEach((item) => {
    const productionCenter = item.productionCenter || "Unknown P C";
    const productionCenterId = item.productionCenterId || "";
    const printerId = item?.printerId || "";

    if (productionCenterId && !receiptData?.externalId) {
      hasProductionCenter = true;

      if (!productionCenters[productionCenter]) {
        tokenCounter++;
        const newToken = `T-${tokenCounter}`;

        productionCenters[productionCenter] = {
          productionCenter,
          productionCenterId,
          token: newToken,
          items: [],
          subTotal: 0,
          printerId,
        };

        vendors.push(productionCenters[productionCenter]);
      }

      productionCenters[productionCenter].items.push({
        name: item.name || "",
        weight: item.weight || 1,
        grossunit: parseFloat(item.grossunit || item.salePrice || 0).toFixed(2),
        linegross: parseFloat(item.linegross || item.nettotal || 0).toFixed(2),
        addons: item.selectedAddons || item.addons || [],
        preparationTime: item?.preparationTime || null,
        notes: item?.notes || null,
      });

      productionCenters[productionCenter].subTotal += parseFloat(item.linegross || 0);
    }
  });

  // Case 1: Aggregator
  if (receiptData?.externalId && !disableAggregatorKOTPrint) {
    CWKOTPrinter(receiptData, true);
  }

  // Case 2: Production Centers → Multiple Prints (1 per PC)
  // else {
  //   vendors.forEach((vendor) => {
  //     CWKOTPrinter(vendor, false);
  //   });
  // }

  // Store updated token data only if at least one item was processed (i.e., vendors exist)
  if (vendors.length > 0) {
    storedTokenData.date = currentDate;
    storedTokenData[currentDate] = tokenCounter; // Update for the current date
    useRestaurantStore.getState().setTokenData(storedTokenData);
  }
  receiptData.vendorsCount = vendors.length.toString();
  // Add vendors to receiptData
  receiptData.vendors = vendors;
  receiptData.token = `T-${tokenCounter}`;
  // Set orderDate from cart data or current date
  receiptData.orderDate = printData.orderDate || new Date().toISOString().split("T")[0];

  if (Array.isArray(receiptData.items)) {
    receiptData.items = receiptData.items.map((item, index) => ({
      ...item,
      index,
      ediCode: Array.isArray(item.uomData) && item.uomData.length > 0 ? item.uomData[0]?.ediCode || "" : "",
    }));
  }

  // Print KOT only if there are vendors (i.e., items with valid production centers)
  if (posConfig?.enableKOTPrint === "Y" && receiptData?.saleType?.enableKot === "Y" && vendors.length > 0 && tillData?.tillAccess?.cwrTill?.kotPrintTemplate?.xmlcode2) {
    // Call tokens.js for each vendor with the same bill token
    vendors.forEach((vendor) => {
      printToken(vendor, receiptData);
    });
  }

  const sales_receipt_copies = posConfig?.sales_receipt_copies && posConfig?.sales_receipt_copies !== null ? posConfig?.sales_receipt_copies : 0;
  const return_receipt_copies = posConfig?.return_receipt_copies && posConfig?.return_receipt_copies !== null ? posConfig?.return_receipt_copies : 0;
  const layaway_receipt_copies = posConfig?.layaway_receipt_copies && posConfig?.layaway_receipt_copies !== null ? posConfig?.layaway_receipt_copies : 0;
  const layaway_paid_receipt_copies = posConfig?.layaway_paid_receipt_copies && posConfig?.layaway_paid_receipt_copies !== null ? posConfig?.layaway_paid_receipt_copies : 0;
  const loyalty_receipt_copies = posConfig?.loyalty_receipt_copies && posConfig?.loyalty_receipt_copies !== null ? posConfig?.loyalty_receipt_copies : 0;
  const printerURL = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
  let isloyalty =
    (receiptData.payments && receiptData.payments.some((payment) => payment.isloyalty)) ||
    (receiptData?.paymentData && receiptData?.paymentData.some((payment) => payment?.isloyalty));
  const templateId = useTransactionStore.getState().selectedPrintTemplateId || null;
  let docTypeTemplateId = null;
  let printTemplate = null;
  if (templateId) {
    // Check server templates first
    let printTemplates = [];
    try {
      if (tillData?.tillAccess?.cwrTill?.printTemplates) printTemplates = JSON.parse(tillData.tillAccess.cwrTill.printTemplates);
    } catch {
      /* ignore */
    }
    printTemplate = printTemplates?.find((template) => template?.cwr_printtemplate_id === templateId)?.xmlcode2;
    docTypeTemplateId = printTemplates?.find((template) => template?.cwr_printtemplate_id === templateId)?.cs_doctype_template_id;
    // Fallback: check locally designed templates (from Template Designer)
    if (!printTemplate) {
      try {
        const localTemplates = JSON.parse(localStorage.getItem("cwPrintTemplates") || "[]");
        const localMatch = localTemplates.find((t) => t.cwr_printtemplate_id === templateId);
        if (localMatch) {
          printTemplate = localMatch.xmlcode2 || JSON.stringify({ elements: localMatch.elements || [] });
        }
      } catch {
        /* ignore parse errors */
      }
    }
  }
  if (docTypeTemplateId !== null) {
    const isDuplicate = PStatus === "Duplicate Copy";
    const printCount = isDuplicate ? 1 : sales_receipt_copies;
    const formData = new FormData();
    formData.append("windowId", "7004");
    formData.append("tabId", "270EED9D0E7F4C43B227FEDC44C5858F");
    formData.append("recordId", receiptData?.sOrderID || "");
    formData.append("type", "Print-Template");
    formData.append("printTemplateId", docTypeTemplateId);

    const { access_token } = getOAuthHeaders() || {};

    Axios.post(env.downloadPrintTemplatesUrl, formData, {
      headers: {
        Authorization: access_token,
      },
    })
      .then((res) => {
        const fileUrl = res?.data;

        if (!fileUrl) return;

        let successfulPrints = 0;

        for (let i = 0; i < printCount; i++) {
          Axios.post(`${printerURL}printer`, fileUrl, {
            headers: {
              "Content-Type": "text/plain",
            },
          })
            .then(() => {
              console.debug("Print success!");
              successfulPrints++;

              if (successfulPrints === sales_receipt_copies) {
                if (receiptData.layAway === "N" && !PStatus && !receiptData.draftFlag && receiptData?.payments?.some((p) => p?.name === "Cash")) {
                  CWOpenDrawer();
                }

                receiptData.items.forEach((data) => {
                  if (receiptData.isReturn && data?.giftCardType === "DIG") {
                    GiftCardCWHCPrint(data, "Credit Note");
                  } else if (data?.giftCardType === "DIG") {
                    GiftCardCWHCPrint(data, "Gift Card");
                  }
                });
              }
            })
            .catch((err) => {
              console.error("Print failed!", err);
            });
        }
        useTransactionStore.getState().setSelectedPrintTemplateId(null);
      })
      .catch((err) => {
        console.error("Error in print flow:", err);
      });
    useTransactionStore.getState().setSelectedPrintTemplateId(null);
    return;
  }
  let receiptTemplate = {};
  try {
    if (printTemplate) {
      receiptTemplate = JSON.parse(printTemplate);
    } else if (tillData?.tillAccess?.cwrTill?.printTemplate?.xmlcode2) {
      receiptTemplate = JSON.parse(tillData.tillAccess.cwrTill.printTemplate.xmlcode2);
    }
  } catch (e) {
    console.error("[CWHCPrint] Failed to parse receipt template:", e.message);
  }
  const isInterState = getIsInterState(receiptData);
  const groupedItems = {};
  (receiptData.items || []).forEach((item) => {
    const key = item.tax && item.tax.rate !== undefined && item.tax.rate !== null ? item.tax.rate : item.taxRate || "0";
    if (!groupedItems[key]) {
      groupedItems[key] = [];
    }
    groupedItems[key].push(item);
  });

  const groupedItemsByTaxRate = [];
  for (const taxRate in groupedItems) {
    const totalTaxAmount = groupedItems[taxRate].reduce(
      (total, item) =>
        total +
        (item.tax && item.tax.rate !== undefined && item.tax.rate !== null
          ? parseFloat(parseFloat(item.linetax || 0).toFixed(2))
          : parseFloat(parseFloat(item.taxAmount || 0).toFixed(2))),
      0
    );
    const totalNetTotal = groupedItems[taxRate].reduce(
      (total, item) =>
        total +
        (item.tax && item.tax.rate !== undefined && item.tax.rate !== null
          ? parseFloat(parseFloat(item.linegross || 0).toFixed(2))
          : parseFloat(parseFloat(item.nettotal || 0).toFixed(2))),
      0
    );
    const totalSgstAmount = isInterState
      ? 0
      : groupedItems[taxRate].reduce((total, item) => total + parseFloat(parseFloat(item.sgst || item.tax?.sgst || (item.taxAmount || 0) / 2).toFixed(2)), 0);
    const totalCgstAmount = isInterState
      ? 0
      : groupedItems[taxRate].reduce((total, item) => total + parseFloat(parseFloat(item.cgst || item.tax?.cgst || (item.taxAmount || 0) / 2).toFixed(2)), 0);
    groupedItemsByTaxRate?.push({
      taxRate: taxRate,
      totalLinenet: (totalNetTotal - totalTaxAmount).toFixed(2),
      totalLinetax: totalTaxAmount.toFixed(2),
      totalLinegross: totalNetTotal.toFixed(2),
      totalSgst: totalSgstAmount.toFixed(2),
      totalCgst: totalCgstAmount.toFixed(2),
      totalIgst: isInterState ? totalTaxAmount.toFixed(2) : "0.00",
    });
  }

  // Extract values from customer.metaData
  const GST_META_KEYS = ["Gst No", "G ST No", "GST No", "GST Number", "gstNo"];
  let gstNo = "";
  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const gstObj = receiptData.customer.metaData.find((item) => GST_META_KEYS.includes(item.key));
    // Fall back to taxId — some store configs store GST in the taxId field
    gstNo = gstObj?.value || receiptData.customer?.taxId || "";
  }

  let legalName = "";
  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const legalNameObj = receiptData.customer.metaData.find((item) => item.key === "Company Name");
    legalName = legalNameObj?.value || receiptData.customer?.legalName || "";
  }

  // Use Zustand — same source as useOrderProcessing.js (localStorage is cleared after order save)
  const isB2b = useTransactionStore.getState().isB2bEnabled === "true";

  let addressLine1 = "";
  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const b2bFlag = localStorage.getItem("isB2bEnabled") === "true";
    let customerConfig = [];
    try {
      customerConfig = JSON.parse(localStorage.getItem("customerConfigs")) || [];
    } catch {
      /* ignore */
    }
    let customerConfigData = {};
    try {
      if (customerConfig[0]?.configuration) customerConfigData = JSON.parse(customerConfig[0].configuration);
    } catch {
      /* ignore */
    }
    const retailCustomerGroups = customerConfigData?.fieldGroups || [];
    if (b2bFlag && retailCustomerGroups.length > 0) {
      const groupId = retailCustomerGroups?.find((g) => g.name === "Invoicing Address")?.id;
      const rawVal = groupId && receiptData.customer.metaData?.find((item) => item.key === groupId)?.value;
      const addressObj = rawVal ? JSON.parse(rawVal) : null;
      addressLine1 = addressObj?.line1 || "";
    } else if (retailCustomerGroups.length > 0) {
      const groupId = retailCustomerGroups?.find((g) => g.name === "Address")?.id;
      const rawVal2 = groupId && receiptData.customer.metaData?.find((item) => item.key === groupId)?.value;
      const addressObj = rawVal2 ? JSON.parse(rawVal2) : null;
      addressLine1 = addressObj?.line1 || "";
    } else {
      const addressObj = receiptData.customer.metaData?.find((item) => item.key === "Line1");
      addressLine1 = addressObj?.value || "";
    }
  }

  let state = "";
  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const stateObj = receiptData.customer.metaData.find((item) => item.key === "State");
    const stateId = stateObj?.value || "";
    const statesData = JSON.parse(localStorage.getItem("statesData")) || [];
    state = statesData.find((item) => item.RecordID === stateId)?.Name || "";
  }

  let country = "";
  if (receiptData?.customer?.metaData && Array.isArray(receiptData.customer.metaData)) {
    const countryObj = receiptData.customer.metaData.find((item) => item.key === "Country");
    const countryId = countryObj?.value || "";
    const countriesData = JSON.parse(localStorage.getItem("countriesData")) || [];
    country = countriesData.find((item) => item.RecordID === countryId)?.Name || "";
  }

  receiptData.customer = {
    ...receiptData.customer,
    gstNo: gstNo,
    legalName: legalName,
    addressLine1: addressLine1,
    country: country,
    state: state,
  };
  // Cashier flow pre-computes groupedItemsByTaxRate as an array; mobile/WebSocket flow sends {} so we fall back to the locally computed one
  const resolvedGroupedItemsByTaxRate =
    Array.isArray(receiptData?.groupedItemsByTaxRate) && receiptData.groupedItemsByTaxRate.length > 0
      ? receiptData.groupedItemsByTaxRate
      : groupedItemsByTaxRate;
  const totalCgst = resolvedGroupedItemsByTaxRate.reduce((sum, row) => sum + Number(row.totalCgst || 0), 0);
  const totalSgst = resolvedGroupedItemsByTaxRate.reduce((sum, row) => sum + Number(row.totalSgst || 0), 0);
  const totalIgst = resolvedGroupedItemsByTaxRate.reduce((sum, row) => sum + Number(row.totalIgst || 0), 0);

  // Always recompute subTotal from active (non-cancelled) items rather than trusting cart.subTotal,
  // which can go stale (e.g. cancel-then-re-add without a fresh sync, BUG-1504). Mirrors the
  // always-recompute approach already used below for totalQty and itemsSummery.
  if (receiptData.items?.length > 0) {
    const activeItemsForSubTotal = receiptData.items.filter((item) => item.isCanceled !== "Y");
    const itemsTotal = activeItemsForSubTotal.reduce((sum, item) => sum + (Number(item.nettotal) || 0), 0);
    const itemsTax = activeItemsForSubTotal.reduce((sum, item) => sum + (Number(item.taxAmount) || 0), 0);
    receiptData.subTotal = parseFloat((itemsTotal - itemsTax).toFixed(pricePrecision ?? 2));
  }

  receiptData.totalQty = (receiptData.items || []).filter((item) => item.isCanceled !== "Y").reduce((sum, item) => sum + (Number(item.weight) || 1), 0);

  // Mobile app sends itemsSummery: {} — compute it from items so templates using itemsSummery.nonDecimalItems.totalQty resolve correctly
  if (!receiptData.itemsSummery || Object.keys(receiptData.itemsSummery).length === 0) {
    const activeItems = (receiptData.items || []).filter((item) => item.isCanceled !== "Y");
    const nonDecItems = activeItems.filter((item) => !item.isDecimalQty);
    const decItems = activeItems.filter((item) => item.isDecimalQty);
    receiptData.itemsSummery = {
      nonDecimalItems: {
        totalQty: nonDecItems.reduce((sum, item) => sum + (Number(item.weight) || 1), 0),
        totalAmount: nonDecItems.reduce((sum, item) => sum + (Number(item.nettotal) || 0), 0),
      },
      decimalItems: {
        totalQty: decItems.reduce((sum, item) => sum + (Number(item.weight) || 0), 0),
        totalAmount: decItems.reduce((sum, item) => sum + (Number(item.nettotal) || 0), 0),
      },
      itemsQty: activeItems.reduce((sum, item) => sum + (Number(item.weight) || 1), 0),
      items: activeItems.length,
    };
  }

  // Merge groupedItemsByTaxRate and PStatus into receiptData.
  // Items are shallow-copied so that salePrice is restored to the original catalog price
  // (realPrice) for receipt display. Pricing rules intentionally set salePrice to the
  // post-discount effective price; realPrice is never modified and always holds the
  // original price. Templates should reference realPrice or salePrice — both now equal
  // the original price in this receipt-scoped copy.
  const receiptItems = (receiptData.items || []).map((item) => ({
    ...item,
    salePrice: item.realPrice ?? item.salePrice,
  }));
  const updatedReceiptData = {
    ...receiptData,
    items: receiptItems,
    groupedItemsByTaxRate: resolvedGroupedItemsByTaxRate,
    totalCgst,
    totalSgst,
    totalIgst,
    PStatus,
    isB2b,
    previousCashBalance: receiptData.customer?.retlLoyaltyBalance + receiptData?.redemptionPoints,
    discountInfo: receiptData.discountInfo || [],
    grossTotal: parseFloat((receiptData.total + (receiptData.discount || 0)).toFixed(pricePrecision ?? 2)),
  };
  console.log("updatedReceiptData ---------->", updatedReceiptData);
  updatedReceiptData.isPreOrderPage = window.location.pathname.includes("/preorder") || receiptData.isPreOrderPage === true;

  const processedReceipt = processReceiptTemplate(receiptTemplate, updatedReceiptData);
  // console.debug("Final Receipt JSON:", JSON.stringify(processedReceipt, null, 2));
  let printReciptData = receiptData;
  let decodedData = JSON.stringify(processedReceipt, null, 2);
  if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    printReciptData.isReturn &&
    printReciptData.layAway === "N" &&
    return_receipt_copies !== 0 &&
    !PStatus &&
    !isloyalty
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < return_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.debug("Print success !");
          successfulPrints++;
          if (successfulPrints === return_receipt_copies) {
            if (printReciptData.layAway === "N" && !PStatus && !printReciptData.draftFlag && printReciptData?.payments?.some((payment) => payment?.name === "Cash")) {
              CWOpenDrawer();
            }
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.debug("XML print failed !", response);
        });
    }
  } else if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    !printReciptData.isReturn &&
    printReciptData.layAway === "N" &&
    sales_receipt_copies !== 0 &&
    !PStatus &&
    !isloyalty
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < sales_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.debug("Print success !");
          useTransactionStore.getState().setSelectedPrintTemplateId(null);
          successfulPrints++;
          if (successfulPrints === sales_receipt_copies) {
            if (printReciptData.layAway === "N" && !PStatus && !printReciptData.draftFlag && printReciptData?.payments?.some((payment) => payment?.name === "Cash")) {
              CWOpenDrawer();
            }
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.debug("Print failed !", response);
          useTransactionStore.getState().setSelectedPrintTemplateId(null);
        });
    }
  } else if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    printReciptData.layAway === "Y" &&
    printReciptData.paid === 0 &&
    layaway_receipt_copies !== 0 &&
    !printReciptData?.externalId &&
    !PStatus
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < layaway_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.debug("Print success !");
          successfulPrints++;
          if (successfulPrints === layaway_receipt_copies) {
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.debug("Print failed !", response);
        });
    }
  } else if (
    printReciptData.items.length > 0 &&
    !printReciptData.draftFlag &&
    printReciptData.layAway === "Y" &&
    printReciptData.paid !== 0 &&
    layaway_paid_receipt_copies !== 0 &&
    !printReciptData?.externalId &&
    !PStatus
  ) {
    let successfulPrints = 0;
    for (let i = 0; i < layaway_paid_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.debug("Print success !");
          successfulPrints++;
          if (successfulPrints === layaway_paid_receipt_copies) {
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((response) => {
          console.debug("Print failed !", response);
        });
    }
  } else if (printReciptData.items.length > 0 && !printReciptData.draftFlag && !PStatus && printReciptData.layAway === "N" && loyalty_receipt_copies !== 0 && isloyalty) {
    let successfulPrints = 0;

    // Loop for printing loyalty receipt copies
    for (let i = 0; i < loyalty_receipt_copies; i++) {
      Axios.post(`${printerURL}printer`, decodedData, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
        .then(() => {
          console.debug("Print success!");
          successfulPrints++;

          // Execute logic after all prints are successful
          if (successfulPrints === loyalty_receipt_copies) {
            if (printReciptData.layAway === "N" && !PStatus && !printReciptData.draftFlag && printReciptData?.payments?.some((payment) => payment?.name === "Cash")) {
              CWOpenDrawer();
            }
            printReciptData.items.forEach((data) => {
              if (printReciptData.isReturn && data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Credit Note");
              } else if (data?.giftCardType === "DIG") {
                GiftCardCWHCPrint(data, "Gift Card");
              }
            });
          }
        })
        .catch((error) => {
          console.error("Print failed!", error);
        });
    }
  } else {
    Axios.post(`${printerURL}printer`, decodedData, {
      headers: {
        "Content-Type": "text/plain",
      },
    })
      .then(() => {
        console.debug("Print success !");
        if (
          (printReciptData.layAway === "N" || (printReciptData.layAway === "Y" && printReciptData.paid !== 0)) &&
          !PStatus &&
          !printReciptData.draftFlag &&
          printReciptData?.payments?.some((payment) => payment?.name === "Cash")
        ) {
          CWOpenDrawer();
        }
        printReciptData.items.forEach((data) => {
          if (printReciptData.isReturn && data?.giftCardType === "DIG") {
            GiftCardCWHCPrint(data, "Credit Note");
          } else if (data?.giftCardType === "DIG") {
            GiftCardCWHCPrint(data, "Gift Card");
          }
        });
      })
      .catch((response) => {
        console.debug("Print failed !", response);
      });
  }
  return processedReceipt;
};

export default CWHCPrint;
